/**
 * Infinite Scroll default declaration
 */
jQuery(function($) {

    $('.infinite-scroll').each(function () {
        var $container = $(this);
        
        // Combine Masonry instance for refresh layout 
        var $masonryInstance = $(this).data('masonry');
        
        $container.infiniteScroll({
            path: '.infinite-posts-navigation a',
            itemSelector: '.infinite-scroll-item',
            hideNav: '.infinite-posts-navigation',
            status: '.infinite-posts-status',
            append: '.infinite-scroll-item',
            outlayer: $masonryInstance,
        
        });
    });
    
});